import { useState, useRef } from 'react';
import gsap from 'gsap';

import { Content as PropsContent } from '@/models/Props';

import { Text, Link, ImgLazy } from '@/components/blocks';
import { Container } from '@/components/containers';
import { LGridSystem } from '@/components/layouts';

import { ReactComponent as ArrowIcon } from '@/assets/svg/icons/arrow.svg';

import './Card.scss';

const Card = ({ content }: PropsContent) => {
    const [shrunk, expand] = useState(true);
    const containerRef = useRef<HTMLElement>(null);
    console.log(content);

    const displayInfo = () => {
        expand(!shrunk);

        gsap.to(containerRef.current, {
            duration: 0.3,
            height: shrunk ? 'auto' : 140,
        });
    };

    return (
        <Container className={'card'}>
            <LGridSystem
                sortChildren={content.idxSection === 0 ? 'rows' : 'columns'}
                positioning={{
                    alignItems: 'center',
                    justifyItems: 'center',
                }}
                gap={1}
            >
                <ImgLazy src={content.asset} />

                <LGridSystem
                    ref={containerRef}
                    dataAttb={
                        content.idxSection === 0
                            ? { 'data-card': 'first' }
                            : undefined
                    }
                    sortChildren={'rows'}
                    gap={0.5}
                >
                    {content.properties.map(
                        (property: any, idxProp: number) => {
                            let props = property;

                            if (content.idxSection > 0 && idxProp > 2) {
                                props = null;
                            }

                            if (!props) {
                                return null;
                            }

                            return (
                                <LGridSystem
                                    key={idxProp}
                                    sortChildren={'rows'}
                                    gap={0.5}
                                >
                                    {!(
                                        !props.normal &&
                                        !Array.isArray(props.list)
                                    ) ? (
                                        <Text
                                            fontStyle={{
                                                size: 'small',
                                                weight: 300,
                                            }}
                                            boldContent={props.bold}
                                            normalContent={props.normal}
                                        />
                                    ) : null}

                                    {Array.isArray(props.list) ? (
                                        <ul>
                                            {props.list.map(
                                                (
                                                    item: any,
                                                    idxList: number
                                                ) => {
                                                    if (!item.normal)
                                                        return null;

                                                    return (
                                                        <li key={idxList}>
                                                            <Text
                                                                fontStyle={{
                                                                    size: 'small',
                                                                    weight: 300,
                                                                }}
                                                                boldContent={
                                                                    item.bold
                                                                }
                                                                normalContent={
                                                                    item.normal
                                                                }
                                                                row
                                                            />
                                                        </li>
                                                    );
                                                }
                                            )}
                                        </ul>
                                    ) : null}
                                </LGridSystem>
                            );
                        }
                    )}

                    {content.idxSection > 0 && content.url ? (
                        <LGridSystem
                            sortChildren={'rows'}
                            positioning={{ justifyItems: 'flex-start' }}
                        >
                            <Link
                                href={content.url}
                                dataAttb={{ 'data-card': 'link' }}
                            >
                                {'More info...'}
                            </Link>
                        </LGridSystem>
                    ) : null}
                </LGridSystem>
            </LGridSystem>

            {content.idxSection === 0 ? (
                <LGridSystem
                    sortChildren={'rows'}
                    positioning={{ justifyItems: 'center' }}
                >
                    <button
                        data-flex={'active'}
                        data-flex-dir={'rows'}
                        data-card={'toogle'}
                        data-card-svg={!shrunk ? 'up' : 'down'}
                        onClick={displayInfo}
                    >
                        {!shrunk ? 'Less info' : 'More info'} <ArrowIcon />
                    </button>
                </LGridSystem>
            ) : null}
        </Container>
    );
};

export default Card;
